import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { getReservationStatusLabel } from './reservation_status_config';

export function RoomsReservationStatusBadge({ status }) {
  const indicatorClass = classNames('event-form-status-indicator', {
    live: status === 'approved',
    pending: status === 'pending' || status === 'under_review' || status === 'partially_approved',
    rejected: status === 'rejected' || status === 'cancelled',
  });

  const statusLabel = getReservationStatusLabel(status);

  return (
    <>
      <span className={indicatorClass} aria-hidden="true">
        <i className="fa fa-circle" />
      </span>
      <span className="reservation-status-text">
        Reservation Status: {statusLabel}
      </span>
    </>
  );
}

RoomsReservationStatusBadge.propTypes = {
  status: PropTypes.oneOf([
    'approved',
    'pending',
    'rejected',
    'cancelled',
    'under_review',
    'partially_approved',
  ]).isRequired,
};
